import { controls } from "../controls";

const dashboard = {
  label: "Home",
  pageLabel: "Dashboard",
  starting: true,
  url: "home",
  pageType: "history",
  dashboard: [
    ...controls.displayText({ width: "col-sm-12", label: " ", tab: "filter" }),
    {
      widths: "col-sm-4",
      tab: "create",
      theme: "orotheme",
      title: "Society Overview icon-selfWhatsApp",
      footer: "for yesterday (in Lakhs)",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list1",
          values: [
            {
              main: {
                desc: "Day Book", url: "daybook",
                payload: { branch_code: { type: "fixed", value: "0002" }, as_on_date: { type: "fixed", value: new Date() } }, value: "Needs Attention", color: "orange", size: 14
              }
            },
            { main: { desc: "Profit & Loss", value: "Rs. 18.97 Crore", color: "#8af07f" } },
            { main: { desc: "Monthly Expenditure", value: "Rs. 12,32,383.43", url: "rp301", color: "orange" } },
            { main: { desc: "Overdue", value: "Rs. 132.43 Crore", url: "rp301", color: "#ff4646" } },
            { main: { desc: "KYC Speed", value: "783 / day", color: "#8af07f" } },
            { main: { desc: "High Risk KYC Pending", value: "13", color: "#8af07f" } },
            { main: { desc: "Satisfaction Index", value: "icon-tick", color: "#8af07f" } },
            { main: { desc: "Compliance Index", value: "icon-tick", color: "#8af07f" } },
          ]
        }),
      ]
    },
    {
      widths: "col-sm-4",
      tab: "create",

      title: "Society Status icon-selfWhatsApp",
      // style:{border:"none"},
      footer: "in Lakhs",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          values: [
            { main: { desc: "Recovery", value: "Rs.3,00,000.00" } },
            { main: { desc: "Mobile Registrations", value: "300" } },
            { main: { desc: "SMS Service", value: "200" } },
            { main: { desc: "RTGS", value: "200" } },
            { main: { desc: "New Deposits", value: "Rs.2,00,000.00" } },
            { main: { desc: "New Loans", value: "Rs.2,00,000.00" } },
            { main: { desc: "CKYC Compliance", value: "100" } },
            { main: { desc: "KYC renewals", value: "10" } },
          ]
        }),
      ]
    },

    {
      widths: "col-sm-4",
      tab: "create",
      title: "Reconcilliation icon-selfWhatsApp",
      // style:{border:"none"},
      footer: "in Lakhs",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          values: [
            { main: { desc: "Society Recovery", value: "Rs.3,00,000.00" } },
            { main: { desc: "Bank Recovery", value: "Rs. 4,00,000.00" } },
            { main: { desc: "Society Disbursement", value: "164" } },
            { main: { desc: "Bank Disbursement", value: "200" } },
            { main: { desc: "Society Overdue", value: "100" } },
            { main: { desc: "Bank Overdue", value: "107" } },
            { main: { desc: "VAS Commission Earned", value: "Rs.1,38,000.00" } },
            { main: { desc: "VAS Commission Disbursed", value: "Rs.1,07,000.00" } },
          ]
        }),
      ]
    },

    {
      widths: "col-sm-4",
      tab: "create",
      title: "My Performance icon-selfWhatsApp",
      // style:{border:"none"},
      selfWhatsApp: "sendsummary",
      footer: "for the previous month",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          values: [
            { main: { desc: "Recovery", value: "Rs.3,00,000.00" } },
            { main: { desc: "Mobile Registrations", value: "300" } },
            { main: { desc: "SMS Service", value: "200" } },
            { main: { desc: "RTGS", value: "200" } },
            { main: { desc: "New Deposits", value: "Rs.2,00,000.00" } },
            { main: { desc: "New Loans", value: "Rs.2,00,000.00" } },
            { main: { desc: "CKYC Compliance", value: "100" } },
            { main: { desc: "KYC renewals", value: "10" } },
          ]
        }),
      ]
    },
    {
      widths: "col-sm-4",
      tab: "create",
      theme: "targettheme",
      selfWhatsApp: "sendsummary",
      title: "My Targets icon-selfWhatsApp",
      // style:{border:"none"},
      footer: "for the current month",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          values: [
            { main: { desc: "Recovery", value: "Rs.3,00,000.00" } },
            { main: { desc: "Mobile Registrations", value: "300" } },
            { main: { desc: "SMS Service", value: "200" } },
            { main: { desc: "RTGS", value: "200" } },
            { main: { desc: "New Deposits", value: "Rs.2,00,000.00" } },
            { main: { desc: "New Loans", value: "Rs.2,00,000.00" } },
            { main: { desc: "CKYC Compliance", value: "100" } },
            { main: { desc: "KYC renewals", value: "10" } },
          ]
        }),
      ]
    },

    {
      widths: "col-sm-4",
      tab: "create",
      selfWhatsApp: "sendsummary",
      title: "Pending CKYC icon-selfWhatsApp",
      style: { paddingRight: 0 },
      subComponents: [
        ...controls.FollowupList({
          name: "pending_kyc", values: [
            { main: { desc: "Mayur Leve" }, sub: { desc: { phone: "8829938839", docs: "PAN" }, action: { desc: 'Send SMS', api: "sendsms" } } },
            { main: { desc: "Aniket Dharmadhikari" }, sub: { desc: { phone: "9844758746", docs: "PAN, AADHAAR" }, action: { desc: 'Send SMS', api: "sendsms" } } },
            { main: { desc: "Mangesh Fulari" }, sub: { desc: { phone: "9844777283", docs: "PAN, Mothers Name" }, action: { desc: 'Send SMS', api: "sendsms" } } }

          ]
        }),
      ]
    },
    // ...controls.iframe({ tab: "filter",url:"https://sync.shield.orobanking.com:8000/index-ibos.html", label: "",height:500 }),

    {
      widths: "col-sm-4",
      tab: "create",
      selfWhatsApp: "sendsummary",
      title: "Installments overdue icon-selfWhatsApp",
      footer: "in coming 3 days",
      style: { maxHeight: 303 },
      subComponents: [
        ...controls.FollowupList({
          name: "probable_npa", values: [
            { main: { desc: "Vyankatesh Kurundkar" }, sub: { desc: { phone: "8830033709", ac: "00311100288398", currency: "Rs.12,989.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },
            { main: { desc: "Mangesh Fulari" }, sub: { desc: { phone: "8380006707", ac: "00311100288238", currency: "Rs.8,280.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },
            { main: { desc: "Amrutraj Gore" }, sub: { desc: { phone: "8380006707", ac: "00311100288239", currency: "Rs.5,080.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },

            { main: { desc: "Mahesh Jawale" }, sub: { desc: { phone: "8380006707", ac: "00311100288231", currency: "Rs.3,655.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },

            { main: { desc: "Ajit Kadam" }, sub: { desc: { phone: "8830033709", ac: "00311100288395", currency: "Rs.12,231.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },
            { main: { desc: "Chandrakant Patil" }, sub: { desc: { phone: "8380006707", ac: "00311100288233", currency: "Rs.9,422.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },

            { main: { desc: "Vikram Pawar" }, sub: { desc: { phone: "8830033709", ac: "00311100288396", currency: "Rs.54,123.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },
          ]
        }),
      ]
    },

    {
      widths: "col-sm-4",
      tab: "create",
      selfWhatsApp: "sendsummary",
      title: "Potential NPAs icon-selfWhatsApp",
      footer: "in 10-15 days from now.",
      style: { maxHeight: 303 },
      subComponents: [
        ...controls.FollowupList({
          name: "probable_npa", values: [
            { main: { desc: "Sunil Lagoo" }, sub: { desc: { phone: "8830033709", ac: "00311100288398", currency: "Rs.12,989.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },
            { main: { desc: "Amrutraj Gore" }, sub: { desc: { phone: "8380006707", ac: "00311100288238", currency: "Rs.8,280.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },
            { main: { desc: "Amrutraj Gore" }, sub: { desc: { phone: "8380006707", ac: "00311100288238", currency: "Rs.8,280.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },

            { main: { desc: "Amrutraj Gore" }, sub: { desc: { phone: "8380006707", ac: "00311100288238", currency: "Rs.8,280.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },

            { main: { desc: "Sunil Lagoo" }, sub: { desc: { phone: "8830033709", ac: "00311100288398", currency: "Rs.12,989.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },
            { main: { desc: "Amrutraj Gore" }, sub: { desc: { phone: "8380006707", ac: "00311100288238", currency: "Rs.8,280.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },

            { main: { desc: "Sunil Lagoo" }, sub: { desc: { phone: "8830033709", ac: "00311100288398", currency: "Rs.12,989.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },
          ]
        }),
      ]
    },

    {
      widths: "col-sm-4",
      tab: "create",
      selfWhatsApp: "sendsummary",
      title: "KCC icon-selfWhatsApp",
      footer: "todays birthdays only",
      // style:{border:"none"},
      subComponents: [
        ...controls.FollowupList({
          name: "birthdays", values: [
            { main: { desc: "Chandrakant Patil" }, sub: { desc: { phone: "88399483292", offer: "Get senior citizen discount" }, action: { desc: 'Send SMS', api: "sendsms" } } },
            { main: { desc: "Chandrakant Patil" }, sub: { desc: { phone: "88399483292", offer: "Get senior citizen discount" }, action: { desc: 'Send SMS', api: "sendsms" } } },
            { main: { desc: "Chandrakant Patil" }, sub: { desc: { phone: "88399483292", offer: "Get senior citizen discount" }, action: { desc: 'Send SMS', api: "sendsms" } } },
            { main: { desc: "Chandrakant Patil" }, sub: { desc: { phone: "88399483292", offer: "Get senior citizen discount" }, action: { desc: 'Send SMS', api: "sendsms" } } },
            { main: { desc: "Chandrakant Patil" }, sub: { desc: { phone: "88399483292", offer: "Get senior citizen discount" }, action: { desc: 'Send SMS', api: "sendsms" } } }
          ]
        }),
      ]
    },

    {
      widths: "col-sm-8",
      tab: "create",
      selfWhatsApp: "sendsummary",
      title: "Compliance icon-selfWhatsApp",
      // style:{border:"none"},
      footer: "for the current month",
      subComponents: [
        ...controls.gchart({
          name: "kpi_list",
          values: [
            { main: { desc: "September 2021", url: "gls", value: "icon-cross", color: "red" } },
            { main: { desc: "June 2021", url: "gls", value: "icon-tick", color: "green" } },
          ]
        }),
      ]
    },


  ]
};

export default dashboard;